/** @format */

import {useState} from 'react';
import update from 'immutability-helper';
import SuperAgent from 'superagent';

export default function useLogin({onLogin = false, redirect = false} = {}) {
    const [state, setState] = useState({
        username: '',
        password: '',
        isAuthorizing: false,
        error: false
    });

    const handleLogin = async () => {
        setState({...state, isAuthorizing: true, error: false});
        try {
            const response = await SuperAgent.post('/account/users/login')
                .set('Accept', 'application/json')
                .send({
                    username: state.username,
                    password: state.password
                })
                .query({
                    redirect: redirect
                });

            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'login'
                });
            }

            if (!onLogin) {
                window.location.assign(response.body.redirect);
            } else {
                onLogin({
                    redirect: response.body.redirect,
                    isLoggedIn: true,
                    userId: response.body.id
                });
            }
        } catch (e) {
            setState({
                ...state,
                isAuthorizing: false,
                error: 'Oops, your username or password is incorrect'
            });
        }
    };

    return {
        ...state,
        isComplete: () => {
            const {username, password} = state;

            const isUsernameFilled = username !== '' && username !== undefined,
                isPasswordFialled = password !== '' && password !== undefined;

            return isUsernameFilled && isPasswordFialled ? true : false;
        },
        onKeyPress: e => {
            if (e.keyCode === 13) {
                handleLogin();
            }
        },
        onSubmitLogin: handleLogin,
        onInputChange: (field, e) => {
            const value = typeof e?.target?.value !== 'undefined' ? e.target.value : e;
            setState(update(state, {[field]: {$set: value}}));
        }
    };
}
